export default {
    basePath: '/webmotorstv',
    getFontSize: size => `
        font-size: ${size}px;
		line-height: calc(${size}px + 33.33%);
    `,
};
